import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Countries from "./pages/Countries/Countries";
import Home from "./pages/Home/Home";
import Matches from "./pages/Matches/Matches";
import News from "./pages/News/News";
import Standings from "./pages/Standings/Standings";
import Login from "./pages/Login/Login";
import Detail from "./pages/Detail/Detail";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/home" element={<Home />} />
        <Route path="/" element={<Home />} />
        <Route path="/news" element={<News />} />
        <Route path="/country" element={<Countries />} />
        <Route path="/standing" element={<Standings />} />
        <Route path="/match" element={<Matches />} />
        <Route path="/login" element={<Login />} />
        <Route path="/detail/:numericCode" element={<Detail />} />
        {/*<Route path = "*" element= {<Home />} />*/}
      </Routes>
    </BrowserRouter>
  );
};

export default App;
